const NavbarSlidingSubmenu = require('./NavbarSlidingSubmenu')

module.exports = NavbarSlidingSubmenu